/**
 * Visibilité des entrées du menu avatar (BL-0247 / BL-0245 / BL-0244 / BL-0246 / BL-0334 / BL-0339).
 * Principe : masquer plutôt que griser.
 * Mon profil (BL-0334) : flag + U2106:READ uniquement (sans gate hasEmployee).
 * Mon organisation (BL-0339) : U3148:READ et organizationId présent dans le jeton.
 */

export const U2000_USER_MENU_U3148_READ_ROLE = 'U3148:READ';
export const U2000_USER_MENU_U2106_CHANGEPASSWORD_ROLE = 'U2106:CHANGEPASSWORD';
export const U2000_USER_MENU_U2106_READ_ROLE = 'U2106:READ';

export type U2000UserMenuFeatureFlags = {
  profileAvailable: boolean;
  changePasswordAvailable: boolean;
  aiUsageAvailable: boolean;
};

/** Flags U2106 — toutes les entrées self-service disponibles. */
export const U2000_USER_MENU_U2106_FLAGS: U2000UserMenuFeatureFlags = {
  profileAvailable: true,
  changePasswordAvailable: true,
  aiUsageAvailable: true,
};

export type U2000UserMenuVisibility = {
  showMyProfile: boolean;
  showChangePassword: boolean;
  showMyAiUsage: boolean;
  showMyOrganization: boolean;
  showMenuActions: boolean;
};

/** Gate commun « Mon organisation » (menu avatar, latéral, route). */
export function u2000CanAccessMyOrganization(
  hasU3148Read: boolean,
  organizationId: string | null | undefined,
): boolean {
  return hasU3148Read && Boolean(organizationId);
}

export function u2000ComputeUserMenuVisibility(
  hasU3148Read: boolean,
  flags: U2000UserMenuFeatureFlags = U2000_USER_MENU_U2106_FLAGS,
  hasChangePasswordRole = false,
  hasU2106Read = false,
  _hasEmployeeProfile = false,
  hasAiProviders = false,
  hasOrganizationId = false,
  /** BL-0520 — masquer changer MDP si compte Google exclusif. */
  ssoEnabled = false,
): U2000UserMenuVisibility {
  // BL-0334 : ne plus exiger hasEmployee — écran U2106 affiche le message si aucune fiche.
  const showMyProfile = flags.profileAvailable && hasU2106Read;
  const showChangePassword =
    flags.changePasswordAvailable && hasChangePasswordRole && !ssoEnabled;
  const showMyAiUsage = flags.aiUsageAvailable && hasU2106Read && hasAiProviders;
  // BL-0339 : U3148:READ seul ne suffit plus sans organizationId de session.
  const showMyOrganization = u2000CanAccessMyOrganization(
    hasU3148Read,
    hasOrganizationId ? 'present' : null,
  );
  return {
    showMyProfile,
    showChangePassword,
    showMyAiUsage,
    showMyOrganization,
    showMenuActions: showMyProfile || showChangePassword || showMyAiUsage || showMyOrganization,
  };
}

export function u2000UserMenuInitials(fullName: string): string {
  return fullName
    .split(' ')
    .filter((part) => part.length > 0)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}
